import React from 'react';
import { Pagination as CorePagination } from 'is24-corecss';
export var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    onChange = _ref.onChange;
  var handlePageClick = function handlePageClick(_event, page) {
    if (typeof page === 'number') {
      onChange(page);
    }
  };
  return /*#__PURE__*/React.createElement(CorePagination, {
    pages: totalPages,
    activePage: currentPage,
    onClickPage: handlePageClick,
    onClickPrev: handlePageClick,
    onClickNext: handlePageClick
  });
};